const SIGNED_QUERY_KEYS = [
  "X-Goog-Algorithm",
  "X-Goog-Signature",
  "X-Goog-Credential",
  "GoogleAccessId",
  "Signature",
  "Expires",
  "X-Amz-Algorithm",
  "X-Amz-Signature",
  "X-Amz-Credential",
] as const;

export const isLikelySignedObjectUrl = (value: string): boolean => {
  try {
    const parsed = new URL(value);
    return SIGNED_QUERY_KEYS.some((key) => parsed.searchParams.has(key));
  } catch {
    return false;
  }
};

/** Signed URL의 canonical query를 변경하면 403이 발생하므로 서명 URL은 원본 그대로 사용한다. */
export const appendCacheBusterIfUnsigned = (
  value: string,
  version: number = Date.now(),
): string => {
  if (!value || isLikelySignedObjectUrl(value)) return value;
  return `${value}${value.includes("?") ? "&" : "?"}v=${version}`;
};
